import React, { useEffect, useState } from "react";
import * as S from "./TabelaSaquesStyle";
import { goldenBoxService } from "../../../Services/goldenBoxService";
import { formatNumber } from "../../../assets/utils";
import { FaSpinner } from "react-icons/fa";
import WithdrawModal from "../WithdrawModal/WithdrawModal";

// Recebe a prop onUpdateDashboard
export default function TabelaSaques({ onUpdateDashboard }) {
  const [withdraws, setWithdraws] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);

  const [selectedWithdraw, setSelectedWithdraw] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const limit = 10;

  const fetchWithdraws = async () => {
    try {
      setLoading(true);
      const offset = (page - 1) * limit;
      const response = await goldenBoxService.getMyWithdraws(limit, offset);
      setWithdraws(response.data || []);
      setTotalCount(response.totalCount || 0);
    } catch (error) {
      console.error("Erro ao buscar saques", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdraws();
  }, [page]);

  const handleRowClick = (item) => {
    setSelectedWithdraw(item);
    setIsModalOpen(true);
  };

  // Função combinada para atualizar tabela E dashboard
  const handleModalSuccess = () => {
    fetchWithdraws(); // Atualiza a tabela
    if (onUpdateDashboard) {
      onUpdateDashboard(); // Atualiza o saldo do dashboard
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "PENDING":
        return "Pendente";
      case "PAID":
        return "Pago";
      case "CANCELED":
        return "Cancelado";
      case "REJECTED":
        return "Rejeitado";
      default:
        return status || "Desconhecido";
    }
  };

  const totalPages = Math.ceil(totalCount / limit);

  if (loading && withdraws.length === 0) {
    return (
      <S.Container style={{ display: "flex", justifyContent: "center" }}>
        <FaSpinner
          className="spinner"
          size={24}
          color="#D4AF37"
          style={{ animation: "spin 1s linear infinite" }}
        />
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </S.Container>
    );
  }

  return (
    <>
      <S.Container>
        {withdraws.length === 0 ? (
          <S.EmptyState>Nenhum saque encontrado.</S.EmptyState>
        ) : (
          <>
            <S.Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Data Solicitação</th>
                  <th>Caixinha ID</th>
                  <th>Valor Solicitado</th>
                  <th>Valor a Receber</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {withdraws.map((item) => (
                  <tr key={item.id} onClick={() => handleRowClick(item)}>
                    <td>#{item.id}</td>
                    <td className="date">
                      {item.dateCreated
                        ? new Date(item.dateCreated).toLocaleDateString("pt-BR")
                        : "-"}
                    </td>
                    <td>{item.goldenBoxId ? `#${item.goldenBoxId}` : "-"}</td>
                    <td className="amount">
                      R$ {formatNumber(item.amountWithdrawn)}
                    </td>
                    <td className="amount" style={{ color: "#059669" }}>
                      R${" "}
                      {formatNumber(
                        item.amountWithdrawnReceivable ?? item.amountWithdrawn
                      )}
                    </td>
                    <td>
                      <S.StatusBadge status={item.status}>
                        {getStatusLabel(item.status)}
                      </S.StatusBadge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </S.Table>

            {totalCount > limit && (
              <S.PaginationContainer>
                <span>
                  Página {page} de {totalPages}
                </span>
                <S.PageButton
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Anterior
                </S.PageButton>
                <S.PageButton
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Próxima
                </S.PageButton>
              </S.PaginationContainer>
            )}
          </>
        )}
      </S.Container>

      <WithdrawModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={selectedWithdraw}
        onSuccess={handleModalSuccess} // Passa a função combinada
      />
    </>
  );
}
